<div class="card mb-3">
  <div class="card-header" [style.cursor]="collapsible ? 'pointer' : 'default'" (click)="collapsible && (isOpen = !isOpen)">
    <i class="fa fa-cogs"></i> Configurations
    @if (collapsible) {
      <div class="pull-right">
        @if (isOpen) {
          <i class="fa fa-chevron-down"></i>
        } @else {
          <i class="fa fa-chevron-left"></i>
        }
      </div>
    }
  </div>
  <div class="card-body" [collapse]="collapsible && !isOpen">
    @if (isLoading) {
      <div class="text-center py-3">
        <span class="spinner-border spinner-border-sm"></span> Loading...
      </div>
    } @else {
      <table class="table table-sm table-hover mb-0">
        <thead class="thead-light">
          <tr>
            <th style="width:240px">Configuration</th>
            <th>Global</th>
            <th>Application Override</th>
            <th class="text-end">
              <button class="btn btn-sm btn-success"
                      [disabled]="!hasPendingChanges || isSaving"
                      (click)="onClickSave()">
                @if (isSaving) {
                  <span class="spinner-border spinner-border-sm"></span>
                } @else {
                  <i class="fa fa-save"></i>
                }
                Save
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (def of configurations; track def.name) {
            <tr>
              <td>
                <strong>{{ def.label }}</strong><br>
                <small class="text-muted">{{ def.description || def.name }}</small>
              </td>
              <!-- Global -->
              <td>
                @if (!discoveryMode || globalExists[def.name]) {
                  @if (def.type === 'bool') {
                    <div class="form-check form-switch mb-0">
                      <input class="form-check-input" type="checkbox"
                             [checked]="valuesGlobal[def.name] === 1"
                             (change)="onBoolChange(valuesGlobal, def.name, $any($event.target).checked)">
                    </div>
                  } @else if (def.type === 'number') {
                    <input type="number" class="form-control form-control-sm" style="width:130px"
                           [(ngModel)]="valuesGlobal[def.name]">
                  } @else {
                    <input type="text" class="form-control form-control-sm" style="width:200px"
                           [(ngModel)]="valuesGlobal[def.name]">
                  }
                } @else {
                  <span class="text-muted">-</span>
                }
              </td>
              <!-- App override -->
              <td>
                @if (!appHasOverride[def.name]) {
                  <button class="btn btn-sm btn-secondary" (click)="onClickOverride(def.name)">
                    <i class="fa fa-plus"></i> Override
                  </button>
                } @else {
                  <div class="d-flex align-items-center gap-2">
                    @if (def.type === 'bool') {
                      <div class="form-check form-switch mb-0">
                        <input class="form-check-input" type="checkbox"
                               [checked]="valuesApp[def.name] === 1"
                               (change)="onBoolChange(valuesApp, def.name, $any($event.target).checked)">
                      </div>
                    } @else if (def.type === 'number') {
                      <input type="number" class="form-control form-control-sm" style="width:130px"
                             [(ngModel)]="valuesApp[def.name]">
                    } @else {
                      <input type="text" class="form-control form-control-sm" style="width:200px"
                             [(ngModel)]="valuesApp[def.name]">
                    }
                    @if (!discoveryMode || globalExists[def.name]) {
                      <button class="btn btn-sm btn-danger" (click)="onClickDeleteOverride(def.name)"
                              tooltip="Delete application override" placement="top">
                        <i class="fa fa-trash"></i>
                      </button>
                    }
                  </div>
                }
              </td>
              <td></td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</div>
